import { useEffect, useState } from "react";
import Footer from "@/components/Footer";
import Header from "@/components/Header";
import { Button } from "@/components/ui/button";
import PressRelease from "@/components/PressRelease";
import NewsletterSignup from "@/components/NewsletterSignup";
import img from "../../public/lovable-uploads/0b3c3dab-7f08-4fa2-9306-06615336a55a.png";
import { fetchNewsCategories, fetchNewsPosts } from "@/api/apis";
import JournalistArticles from "@/components/JournalistArticle";
import moment from "moment";
// Press releases will be populated with authentic content
const pressReleases: any[] = [
  {
    title:
      "MUSIC NATION APPROVED BY UNITED ARAB EMIRATES TO LAUNCH WORLD-CLASS COLLECTIVE MANAGEMENT ORGANIZATION, PROVIDING VITAL NEW ROYALTIES FOR MUSIC RIGHTS HOLDERS",
    date: "June 3, 2025",
    location: "Abu Dhabi, UAE",
    subheading:
      "UAE Ministry of Economy issues permit for Music Nation’s advanced platform to license, collect and distribute public performance and neighboring rights royalties",
    content: `
    <div class="prose prose-invert max-w-none">
      <p><strong>ABU DHABI, United Arab Emirates-</strong>Music Nation Copyrights Management (Music Nation), a pioneer in music rights management in the United Arab Emirates, today announced the company received formal approval to license, collect and distribute royalties from public performance and neighboring rights, delivering a vital new source of revenue for music rights holders.</p>
      <p>With best-in-class tools, technology and leading industry partnerships with Broadcast Music Inc. (BMI), the largest performing rights organization in the world, and SoundExchange Inc., the recording industry's top digital global collective management organization, Music Nation will be the industry's first rights management organization capable of natively collecting performance, mechanical and neighboring rights.</p>
      <p>Music Nation is part of a broad UAE initiative to support the creation of a thriving music ecosystem and to elevate the region’s music industry by protecting the rights of music creators and compensating them for the commercial use of their work...</p>
      <p>Music Nation will begin collecting royalties in the UAE for more than 2 million songwriters, composers, publishers, artists, sound recording owners and other music creators.</p>
      <p>The UAE and the broader Middle East and North Africa (MENA) region remain the fastest-growing music market in the world, with the IFPI reporting the territory expanded in 2024 for a tenth consecutive year. Music revenue in MENA last year climbed by 22.8%, outpacing the global average of 5.9% growth.</p>
      <p><strong>About Music Nation</strong></p>
      <p>Music Nation, a pioneer in music rights management in the UAE, licenses the rights of authors, publishers, sound recording owners and performers throughout the United Arab Emirates (UAE)...</p>
    </div>
    <div class="prose prose-invert max-w-none"><p class="text-musicGrey leading-relaxed mb-6">
      <p><strong>ABU DHABI, United Arab Emirates-</strong>Music Nation Copyrights Management (Music Nation), a pioneer in music rights management in the United Arab Emirates, today announced the company received formal approval to license, collect and distribute royalties from public performance and neighboring rights, delivering a vital new source of revenue for music rights holders.</p>
      <p>With best-in-class tools, technology and leading industry partnerships with Broadcast Music Inc. (BMI), the largest performing rights organization in the world, and SoundExchange Inc., the recording industry's top digital global collective management organization, Music Nation will be the industry's first rights management organization capable of natively collecting performance, mechanical and neighboring rights.</p>
      <p>Music Nation is part of a broad UAE initiative to support the creation of a thriving music ecosystem and to elevate the region’s music industry by protecting the rights of music creators and compensating them for the commercial use of their work...</p>
      <p>Music Nation will begin collecting royalties in the UAE for more than 2 million songwriters, composers, publishers, artists, sound recording owners and other music creators.</p>
      <p>The UAE and the broader Middle East and North Africa (MENA) region remain the fastest-growing music market in the world, with the IFPI reporting the territory expanded in 2024 for a tenth consecutive year. Music revenue in MENA last year climbed by 22.8%, outpacing the global average of 5.9% growth.</p>
      <p><strong>About Music Nation</strong></p>
      <p>Music Nation, a pioneer in music rights management in the UAE, licenses the rights of authors, publishers, sound recording owners and performers throughout the United Arab Emirates (UAE)...</p>
    </p><blockquote class="border-l-4 border-musicRed pl-6 py-4 my-6 bg-musicBlack/30 rounded-r-md"><p class="text-musicWhite italic text-lg mb-2">"Today marks a pivotal moment for the UAE and Music Nation. After years of careful planning, Music Nation is positioned to become a cornerstone of music licensing, empowering the Emirates’ vibrant creative industry."</p><cite class="text-musicRed font-medium">Rasha Khalifa Al Mubarak<span class="text-musicGrey">, Chairwoman</span></cite></blockquote><blockquote class="border-l-4 border-musicRed pl-6 py-4 my-6 bg-musicBlack/30 rounded-r-md"><p class="text-musicWhite italic text-lg mb-2">"The Ministry continues its efforts to develop an advanced system for the governance of copyright and related rights..."</p><cite class="text-musicRed font-medium">H.E. Abdullah Ahmed Al Saleh<span class="text-musicGrey">, Undersecretary of the Ministry of Economy</span></cite></blockquote><blockquote class="border-l-4 border-musicRed pl-6 py-4 my-6 bg-musicBlack/30 rounded-r-md"><p class="text-musicWhite italic text-lg mb-2">"We are thrilled to partner with Rasha, the Music Nation team and SoundExchange to ensure that music creators in the UAE have the opportunity to turn their passion into their careers..."</p><cite class="text-musicRed font-medium">Mike O’Neill<span class="text-musicGrey">, President and CEO of BMI</span></cite></blockquote><blockquote class="border-l-4 border-musicRed pl-6 py-4 my-6 bg-musicBlack/30 rounded-r-md"><p class="text-musicWhite italic text-lg mb-2">"This is a major milestone and a vote of confidence from the UAE Ministry of Economy..."</p><cite class="text-musicRed font-medium">Michael Huppe<span class="text-musicGrey">, President and CEO of SoundExchange</span></cite></blockquote></div>
    `,
    quotes: [],
    contact: {
      phone: "press@wearemusicnation.ae",
      email: "press@wearemusicnation.ae",
    },
    img,
    boilerplate:
      "Music Nation licenses the rights of authors, publishers, sound recording owners and performers throughout the UAE...",
  },
];

// Updated NewsroomHero component with reduced padding
const NewsroomHero = () => {
  return (
    <section className=" relative overflow-hidden pt-24 pb-12">
      {/* Noise texture */}
      <div className="noise-overlay"></div>

      {/* Light blob effects */}
      <div className="light-blob light-blob--1"></div>
      <div className="light-blob light-blob--2"></div>

      <div className="editorial-container">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-white font-serif text-4xl md:text-6xl font-bold mb-6 animate-slide-in-top">
            Newsroom
          </h1>
          <p
            className="font-sans text-xl md:text-2xl text-musicGrey max-w-3xl mx-auto animate-slide-in-top"
            style={{ animationDelay: "0.2s" }}
          >
            The latest news and announcements from Music Nation.
          </p>
        </div>
      </div>
    </section>
  );
};

export default function Newsroom() {
  const [expandedRelease, setExpandedRelease] = useState<number>(1);

  const [categories, setCategories] = useState([]);
  const [activeSection, setActiveSection] = useState(0);

  const [posts, setPosts] = useState([]);

  useEffect(() => {
    fetchNewsCategories().then((res) => {
      setCategories(res.data);
    });

    fetchNewsPosts().then((res) => {
      setPosts(res.data);
    });
  }, []);

  const toggle = (id: number) =>
    setExpandedRelease(expandedRelease === id ? 0 : id);

  return (
    <div className="min-h-screen bg-musicBlack">
      <Header />
      <NewsroomHero />

      {/* Navigation Tabs */}
      <section className="bg-musicBlack border-b border-musicGrey/20">
        <div className="editorial-container">
          <div className="flex justify-center">
            <div className="flex bg-black/50 rounded-lg p-1">
              {categories.map((cat, i) => (
                <button
                  key={cat.id}
                  onClick={() => setActiveSection(i)}
                  className={`px-6 py-3 rounded-md font-medium transition-all duration-300 font-sans ${
                    activeSection === i
                      ? "bg-musicRed text-white shadow-lg"
                      : "text-musicGrey hover:text-white hover:bg-musicGrey/10"
                  }`}
                >
                  {cat.title}
                </button>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Press Releases Section */}
      {categories.length > 0 && (
        <section className="section-dark py-16">
          <div className="editorial-container">
            <div className="max-w-4xl mx-auto">
              <h2 className="font-serif text-3xl font-bold text-musicWhite mb-4 text-center">
                {categories[activeSection].title}
              </h2>
              <p className="font-sans text-musicGrey text-center mb-12 max-w-2xl mx-auto">
                {categories[activeSection].description}
              </p>

              {activeSection == 0 && (
                <div className="space-y-8">
                  {posts.filter(
                    (p) => p.category_id == categories[activeSection].id
                  ).length > 0 ? (
                    posts
                      .filter(
                        (p) => p.category_id == categories[activeSection].id
                      )
                      .map((r: any) => (
                        <PressRelease
                          key={r.id}
                          title={r.title}
                          date={moment(r.publish_date).format("MMMM DD, YYYY")}
                          location={r.location}
                          subheading={r.description}
                          content={r.content.html}
                          quotes={r.content.qoutes || []}
                          features={r.features}
                          contact={{
                            phone: "press@wearemusicnation.ae",
                            email: "press@wearemusicnation.ae",
                          }}
                          boilerplate={
                            "Music Nation licenses the rights of authors, publishers, sound recording owners and performers throughout the UAE..."
                          }
                          isExpanded={expandedRelease === r.id}
                          onToggle={() => toggle(r.id)}
                          img={r.img}
                        />
                      ))
                  ) : (
                    <div className="text-center py-12">
                      <div className="bg-musicGrey/10 rounded-lg p-8 max-w-md mx-auto">
                        <h3 className="font-serif text-xl font-bold text-musicWhite mb-4">
                          Press Releases Coming Soon
                        </h3>
                        <p className="font-sans text-musicGrey mb-6">
                          We're preparing to showcase our official press
                          releases and announcements.
                        </p>
                        <Button
                          className="cta-button"
                          onClick={() =>
                            (window.location.href =
                              "mailto:contact@wearemusicnation.ae")
                          }
                        >
                          Contact Press Team
                        </Button>
                      </div>
                    </div>
                  )}
                </div>
              )}

              {activeSection == 1 && (
                <>
                  <div className="space-y-6">
                    {posts.filter(
                      (p) => p.category_id == categories[activeSection].id
                    ).length > 0 ? (
                      posts
                        .filter(
                          (p) => p.category_id == categories[activeSection].id
                        )
                        .map((article, i) => (
                          <JournalistArticles article={article} />
                        ))
                    ) : (
                      <div className="text-center py-12">
                        <div className="bg-musicGrey/10 rounded-lg p-8 max-w-md mx-auto">
                          <h3 className="text-xl font-bold text-musicWhite mb-4">
                            Media Coverage Coming Soon
                          </h3>
                          <p className="text-musicGrey mb-6">
                            We're curating articles and media coverage about
                            Music Nation from leading publications.
                          </p>
                          <Button
                            className="cta-button"
                            onClick={() =>
                              (window.location.href =
                                "mailto:press@wearemusicnation.ae")
                            }
                          >
                            Contact Press Team
                          </Button>
                        </div>
                      </div>
                    )}
                  </div>

                  <div className="text-center mt-12">
                    <p className="text-musicBlack/60 mb-4">
                      Have a story about Music Nation? We'd love to hear from
                      you.
                    </p>
                    <Button
                      className="cta-button"
                      onClick={() =>
                        (window.location.href =
                          "mailto:press@wearemusicnation.ae")
                      }
                    >
                      Contact Press Team
                    </Button>
                  </div>
                </>
              )}
            </div>
          </div>
        </section>
      )}

      <NewsletterSignup />
      <Footer />
    </div>
  );
}
